import { render, staticRenderFns } from "./RechargeRecord.vue?vue&type=template&id=22fca4f5&scoped=true"
import script from "./RechargeRecord.vue?vue&type=script&lang=js"
export * from "./RechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./RechargeRecord.vue?vue&type=style&index=0&id=22fca4f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fca4f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fca4f5')) {
      api.createRecord('22fca4f5', component.options)
    } else {
      api.reload('22fca4f5', component.options)
    }
    module.hot.accept("./RechargeRecord.vue?vue&type=template&id=22fca4f5&scoped=true", function () {
      api.rerender('22fca4f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Balance/RechargeRecord.vue"
export default component.exports